"use client";

import { StepList } from "@/app/events/[id]/components/StepList";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  BuyTicketsSteps,
  checkoutPayload, isContactFormValid,
  isLoading,
  navigateToStep, patchProfileTicketOrderValues,
  patchProfileValues,
  profileForTicketOrder,
  submitFreeCheckout,
} from "@/app/events/[id]/store/buy-tickets.store";
import React from "react";
import { useSignals } from "@preact/signals-react/runtime";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { Loader } from "@/components/ui/loader";

export const FreeCheckout = () => {
  useSignals();

  const router = useRouter();

  const profile = profileForTicketOrder.value;

  return (
    <>
      <CardContent className="grow overflow-y-auto pb-0">
        <div className="pt-6 mb-6">
          <StepList />
        </div>
        <Card className="mb-6 bg-navy-blue/5 border-purple-200">
          <CardHeader>
            <CardTitle className="text-xl font-medium text-midnight-teal">
              Personal Information
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form className="grid gap-4 sm:grid-cols-2">
              <div className="flex flex-col">
                <Label
                  className="mb-2 text-gray-600 font-normal"
                  htmlFor="firstName"
                >
                  First name <span className="text-red-500">*</span>
                </Label>
                <Input
                  id="firstName"
                  placeholder="Enter first name"
                  value={profile?.firstName}
                  onChange={(e) =>
                    patchProfileValues({ firstName: e.target.value })
                  }
                  required
                />
              </div>
              <div className="flex flex-col">
                <Label
                  className="mb-2 text-gray-600 font-normal"
                  htmlFor="lastName"
                >
                  Last name <span className="text-red-500">*</span>
                </Label>
                <Input
                  id="lastName"
                  placeholder="Enter last name"
                  value={profile?.lastName}
                  onChange={(e) =>
                    patchProfileValues({ lastName: e.target.value })
                  }
                  required
                />
              </div>
              <div className="flex flex-col">
                <Label
                  className="mb-2 text-gray-600 font-normal"
                  htmlFor="email"
                >
                  Email address <span className="text-red-500">*</span>
                </Label>
                <Input
                  value={profile?.email}
                  id="email"
                  type="email"
                  placeholder="Enter email"
                  readOnly={true}
                />
              </div>
              <div className="flex flex-col">
                <Label
                  className="mb-2 text-gray-600 font-normal"
                  htmlFor="phone"
                >
                  Phone number <span className="text-red-500">*</span>
                </Label>
                <Input
                  id="phone"
                  placeholder="Enter phone number"
                  type="tel"
                  value={profile?.contactNumber}
                  onChange={(e) =>
                      patchProfileTicketOrderValues({ contactNumber: e.target.value })
                  }
                  required
                />
              </div>
            </form>
          </CardContent>
        </Card>
      </CardContent>
      <CardFooter className="justify-end pt-6 border-t absolute bottom-0 md:static bg-white w-full md:w-auto">
        <div className="flex justify-between gap-4">
          <Button
            variant="outline"
            onClick={() => navigateToStep(BuyTicketsSteps.SelectTicket)}
          >
            Back
          </Button>
          <Button
            className="flex gap-2 bg-navy-blue hover:bg-navy-blue/85"
            disabled={
              !checkoutPayload?.value?.paymentRecordId || isLoading.value ||  !isContactFormValid.value
            }
            onClick={() => submitFreeCheckout(router.push)}
          >
            {isLoading.value ? <Loader /> : null}
            Place the order
          </Button>
        </div>
      </CardFooter>
    </>
  );
};
